module.exports = __webpack_public_path__ + "media/images/application/template/logos/cita-logo-96bf1ca6eda88270d4f6fc1218c4408f.png";